export default "__VITE_ASSET__7n9e3Qgc__"